<template>
  <div>
    <!-- 表示部分 -->
    <div
      class="ma-0 disp"
      @click="showDialog()"
    >
      <div
        class="text"
        v-text="text"
      ></div>
      <svg
        v-if="!value"
        class="arrow-right"
        width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M8.99953 6.71075C8.60953 7.10075 8.60953 7.73075 8.99953 8.12075L12.8795 12.0008L8.99953 15.8808C8.60953 16.2708 8.60953 16.9008 8.99953 17.2908C9.38953 17.6808 10.0195 17.6808 10.4095 17.2908L14.9995 12.7008C15.3895 12.3108 15.3895 11.6808 14.9995 11.2908L10.4095 6.70075C10.0295 6.32075 9.38953 6.32075 8.99953 6.71075Z" fill="#929191"/>
      </svg>
    </div>

    <!-- 選択ダイアログ -->
    <v-dialog
      v-model="dialog.isShow"
      persistent
      transition="dialog-right-transition"
      scrollable
      content-class="v-dialog-form-bottom"
    >
      <v-card flat>
        <v-card-title
          class="py-3 mb-0 justify-space-between"
          style="border-bottom: 1px solid #D3D2D2"
        >
          <div style="width:28px"></div>
          <span class="font-weight-bold">{{ dialog.text }}</span>
          <v-btn
            icon
            small
            @click="back"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="ma-0 pa-0">
          <v-list
            color="FF5500"
            class="py-0">
            <template
              v-for="(item, index) in dialog.items"
            >
              <v-list-item
                :key="`i-${index}`"
                @click="selectItem(item)"
              >
                <v-list-item-content>
                  <v-list-item-title v-text="item.text"></v-list-item-title>
                </v-list-item-content>
                <!-- <v-list-item-icon>
                  <v-icon color="primary">mdi-chevron-right</v-icon>
                </v-list-item-icon> -->
              </v-list-item>
              <v-divider
                :key="`d-${index}`"
              ></v-divider>
            </template>
          </v-list>
          <!-- <div
            v-for="item in dialog.items"
            :key="item.value"
            class="d-flex align-center list-item"
            @click="selectItem(item)"
          >
            {{ item.text }}
            <svg
              class="arrow-right"
              width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"
            >
              <path d="M8.99953 6.71075C8.60953 7.10075 8.60953 7.73075 8.99953 8.12075L12.8795 12.0008L8.99953 15.8808C8.60953 16.2708 8.60953 16.9008 8.99953 17.2908C9.38953 17.6808 10.0195 17.6808 10.4095 17.2908L14.9995 12.7008C15.3895 12.3108 15.3895 11.6808 14.9995 11.2908L10.4095 6.70075C10.0295 6.32075 9.38953 6.32075 8.99953 6.71075Z" fill="#929191"/>
            </svg>
          </div> -->
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import service from '@/plugins/service'
import btn from '@/components/Like/Button'
import chip from '@/components/Like/Chip'

export default {
  components: {
    btn,
    chip
  },
  props: {
    value: { require: true },
    multiple: { type: Boolean, require: true },
  },
  data: () => ({
    likeList: [],
    dialog: {
      isShow: false,
      text: '',
      isCategory: true,
      items: [],
    },
  }),
  created() {
    service.likeList.forEach(item => this.likeList.push(item))
  },
  computed: {
    text() {
      if (!!this.value) {
        let text = ''
        this.likeList.forEach(item => {
          item.likeList.forEach(subItem => {
            if (subItem.value == this.value) {
              text = `${item.value} > ${subItem.text}`
              return
            }
          })
        })
        return text
      } else {
        return 'Choose a Category'
      }
    },
  },
  methods: {
    showDialog() {
      this.dialog.isShow = true
      this.setCategory()
    },
    selectItem(item) {
      if (!item.d) {
        this.$emit('input', item.value)
        this.dialog.isShow = false
      } else {
        this.dialog.isCategory = false
        this.dialog.text = item.value
        this.dialog.items.splice(0)
        item.likeList.forEach(i => this.dialog.items.push(i))
      }
    },
    back() {
      if (this.dialog.isCategory) {
        this.dialog.isShow = false
      } else {
        this.setCategory()
      }
    },
    setCategory() {
      this.dialog.isCategory = true
      this.dialog.text = 'Choose a Category'
      this.dialog.items.splice(0)
      service.likeList.forEach(item => this.dialog.items.push(item))
    },
  },
}
</script>

<style lang="stylus" scoped>
div.disp
  position relative
  height 40px
  border 1px solid #c5c3c3
  border-radius 8px
  div.text
    position absolute
    top 8px
    left 16px
    height 24px
    font-size 17px
    line-height 24px
  svg.arrow-right
    position absolute
    top 8px
    right 16px

div.card-title
  color #0C0B0B
  height 48px
  line-height 48px
  width 100%
  text-align center
  font-size 18px !important
  font-weight bold

div.list-item
  position relative
  height 48px
  line-height 48px
  font-size 17px
  svg.arrow-right
    position absolute
    right 0
</style>
